import { gql } from '@apollo/client';
import classNames from 'classnames';
import React from 'react';
import type { PostHistoryWrapper_PostFragment } from '../../graphql/generated/graphqlTypes';
import PageMeta from '../../utils/PageMeta';
import styles from './PostHistoryWrapper.module.scss';

const initialTitle = 'History - Slab';

const POST_HISTORY_WRAPPER_POST_FRAGMENT = gql`
  fragment PostHistoryWrapper_post on Post {
    id
    title
  }
`;

interface PostHistoryWrapperProps {
  post?: PostHistoryWrapper_PostFragment | null;
  children?: React.ReactNode;
}

const PostHistoryWrapper = ({ post, children }: PostHistoryWrapperProps) => {
  return (
    <div
      className={classNames(styles.content, 'no-padding-x', 'no-padding-y')}
      id="content"
    >
      <PageMeta
        title={post ? `${post.title} - ${initialTitle}` : initialTitle}
      />
      {children}
    </div>
  );
};

PostHistoryWrapper.fragments = {
  post: POST_HISTORY_WRAPPER_POST_FRAGMENT,
};

export default PostHistoryWrapper;
